import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/FORGOT_PWD_ERROR',
    PENDING: 'Fetch/FORGOT_PWD_PENDING',
    SUCCESS: 'Fetch/FORGOT_PWD_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
